module.exports = __webpack_public_path__ + "static/media/b2_p9_narration.8342e7bf.mp3";